export default __webpack_public_path__ + "images/crosslink-teaser--arrow.svg?2018705038009cc08e60f5477a05ef1e";